export default __webpack_public_path__ + "static/cashflow_202_1996_4-b2a90851ac196abe8a99d14c959962d9.jpeg";